<template>
    <div class="exam-result-management">
        <h3> 로그 > 사용자 이벤트 로그</h3>
        <!-- 검색/필터 영역 -->
        <div class="search-controls">
            <div class="search-row">
                <select v-model="filter.searchType" class="search-type">
                    <option value="">전체</option>
                    <option value="userID">User id</option>
                    <option value="serialNumber">시리얼 번호</option>
                    <option value="event">이벤트 정보</option>
                </select>
                <input v-model="filter.searchText" placeholder="검색어 입력" class="search-input" maxlength="100" />
                <input type="date" v-model="filter.startDate" class="date-input" />
                <span>~</span>
                <input type="date" v-model="filter.endDate" class="date-input" />
            </div>
            <div class="search-button-row">
                <button @click="search()" class="search-btn">검색</button>
                <button @click="resetSearch()" class="reset-btn" >초기화</button>
            </div>
        </div>

        <!-- 목록 정렬 드롭다운 -->
        <div class="list-sort">
            <select v-model="sortOption" @change="search(1)">
                <option value="list">목록 정렬</option>
                <option value="userID">User id</option>
                <option value="serialNumber">시리얼 번호</option>
                <option value="event">이벤트 정보</option>
            </select>
        </div>

        <!-- 결과 목록 테이블 -->
        <table class="result-table">
            <thead>
            <tr>
                <th>no</th>
                <th>user ID</th>
                <th>시리얼 번호</th>
                <th>이벤트 정보</th>
                <th>발생 시간</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, idx) in eventLogList" :key="idx">
                <td>{{ (currentPage - 1) * pageSize + idx + 1 }}</td>
                <td>{{ row.user_id }}</td>
                <td>{{ row.session_id }}</td>
                <td>{{ row.event_type }}</td>
                <td>{{ formatDate(row.event_time) }}</td>
            </tr>
            <tr v-if="eventLogList.length === 0">
                <td colspan="5" style="color:#9ab2ca;">사용자 이벤트 로그가 없습니다.</td>
            </tr>
            </tbody>
        </table>

        <pagination
            :total-items="totalCount"
            :page-size="pageSize"
            v-model="currentPage"
            @page-change="onPageChange"
        />
    </div>
</template>

<script>
import api, {urls} from "@/api";
import Pagination from "@/components/common/Pagination.vue";

export default {
    name: "LogEvent",
    meta: {
        title: "사용자 이벤트 로그"
    },
    components: {Pagination},
    data() {
        return {
            filter: {
                searchType: "",
                searchText: "",
                startDate: "",
                endDate: "",
            },
            sortOption: "list",
            eventLogList: [],
            currentPage: 1,       // 현재 페이지 번호
            pageSize: 10,         // 한 페이지에 보여줄 개수 (필요에 따라 변경 가능)
            totalPages: 1,        // 총 페이지 수 (백엔드에서 받아옴)
            totalCount: 0,        // 총 데이터 개수 (옵션, 백엔드에서 받아옴)
            isLoading: false,
        };
    },
    methods: {
        onPageChange(page) {
            if (this.filter.searchText ||
                this.filter.startDate ||
                this.filter.endDate) {
                this.search(page);  // 검색 시 페이징
            } else {
                this.getlist(page);  // 검색 없이 목록 불러오기
            }
        },
        getlist(page = 1) {
            const params = {
                orderType: this.sortOption,
                startIndex: page,
                pageRow: this.pageSize,
                gubun: 'U'
            };

            api.get(urls.log.userlist, {params: params})
                .then(res => {
                    const data = res.data;
                    this.eventLogList = data.list || [];
                    this.totalCount = res.data.totalCount || this.eventLogList.length;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                    this.currentPage = page;
                })
                .catch(err => {
                    alert("장비 목록 조회 실패");
                    this.eventLogList = [];
                    this.totalCount = 0;
                    this.totalPages = 1;
                    console.error(err);
                })
                .finally(() => {
                        this.isLoading = false;
                    });
        },
        search(page = 1) {
            if (this.filter.startDate && this.filter.endDate) {
                const start = new Date(this.filter.startDate);
                const end = new Date(this.filter.endDate);
                if (start > end) {
                    alert("시작일자는 종료일자보다 작거나 같아야 합니다.");
                    return; // 검색 진행 중단
                }
            }

            const params = {
                searchType: this.filter.searchType,
                searchText: this.filter.searchText,
                startDate: this.filter.startDate,
                endDate: this.filter.endDate,
                sortOption: this.sortOption,
                startIndex: page,
                pageRow: this.pageSize,
                gubun: 'U'
            };

            this.isLoading = true;
            api.get(urls.log.userLogSearch, {params})
                .then(res => {
                    this.eventLogList = res.data.list || [];
                    this.totalCount = res.data.totalCount || this.eventLogList.length;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                    this.currentPage = page;
                })
                .catch(err => {
                    alert('로그 및 활동기록 목록 조회 실패');
                    this.eventLogList = [];
                    this.totalCount = 0;
                    this.totalPages = 1;
                    console.error(err);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        formatDate(dateStr) {
            if (!dateStr) return "";
            const dt = new Date(dateStr);
            return dt.toLocaleString(); // 필요에 맞게 포맷팅 조정
        },
        resetSearch() {
            this.filter = {
                searchType: "",
                searchText: "",
                startDate: "",
                endDate: "",
            };
            this.currentPage = 1;
            this.getlist(1);
        },

    },
    mounted() {
        this.getlist();
    },
    watch: {
        'filter.startDate'(newStart, oldStart) {
            if (newStart && this.filter.endDate) {
                if (new Date(newStart) > new Date(this.filter.endDate)) {
                    alert('시작일자는 종료일자보다 작거나 같아야 합니다.');
                    this.filter.startDate = oldStart;  // 이전 날짜로 되돌리기
                }
            }
        },
        'filter.endDate'(newEnd, oldEnd) {
            if (newEnd && this.filter.startDate) {
                if (new Date(newEnd) < new Date(this.filter.startDate)) {
                    alert('종료일자는 시작일자보다 크거나 같아야 합니다.');
                    this.filter.endDate = oldEnd;  // 이전 날짜로 되돌리기
                }
            }
        }
    }

};
</script>